import http from "../plugins/axios";
const BASE_URI = "/file/guide";
export default {
    getFile() {
        return http.get(`${BASE_URI}`);
    },
    removeFile(id) {
        return http.delete(`${BASE_URI}/${id}`);
    },
    create(formData) {
        return http.post(`${BASE_URI}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    },
};
